import { atom } from 'jotai';

const ineligibleReasonAtom = atom<string>('');
export const RegistrationEligibilityState = {
  ineligibleReasonAtom,
};
